import * as React from 'react';

import { Content } from './Content';
import { Header } from './Header';
import { PublishModal } from './PublishModal';

const VerificationFormPage: React.FC = () => {
  return (
    <>
      <Header />
      <Content />
      <PublishModal />
    </>
  );
};

export default VerificationFormPage;
